import { ThemeComponents } from "@chakra-ui/react";
import Button from "./button";
import Card from "./card";
import Checkbox from "./checkbox";
import { FormLabel } from "./formLabel";
import Input from "./input";
import Radio from "./radio";
import Select from "./select";
import Stat from "./stat";
import Text from "./text";

const components: ThemeComponents = {
  Button,
  Card,
  Checkbox,
  FormLabel,
  Input,
  Radio,
  Stat,
  Select,
  Text,
};

export default components;
